import React, { useState } from 'react';
import { requestPasswordReset, verifyPasswordResetCode, confirmPasswordReset } from '../api';

// Flujo de recuperación de contraseña en 3 pasos, con estado propio:
// 1) pedir código por email, 2) validar el código solo (sin pedir
// contraseña todavía), 3) recién ahí cargar la contraseña nueva.
// El reset_token del paso 2 vive solo en estado de React — nunca en
// localStorage — y se descarta al volver al login.
function RecuperarContrasena({ onVolverALogin }) {
  const [paso, setPaso] = useState(1);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const [email, setEmail] = useState('');
  const [mensajePaso1, setMensajePaso1] = useState('');

  const [codigo, setCodigo] = useState('');

  const [resetToken, setResetToken] = useState('');
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');

  const manejarPedirCodigo = async (e) => {
    e.preventDefault();
    if (!email) { setError('Ingresá tu email.'); return; }
    setError('');
    setCargando(true);
    try {
      const data = await requestPasswordReset(email);
      setMensajePaso1(data.detail || 'Si el email está registrado, vas a recibir un código por correo.');
      setPaso(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  const manejarValidarCodigo = async (e) => {
    e.preventDefault();
    if (!codigo) { setError('Ingresá el código que recibiste por email.'); return; }
    setError('');
    setCargando(true);
    try {
      const data = await verifyPasswordResetCode(email, codigo);
      setResetToken(data.reset_token);
      setPaso(3);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  const manejarNuevaPassword = async (e) => {
    e.preventDefault();
    if (!nuevaPassword || !confirmarPassword) { setError('Completá los dos campos.'); return; }
    if (nuevaPassword !== confirmarPassword) { setError('Las contraseñas no coinciden.'); return; }
    setError('');
    setCargando(true);
    try {
      await confirmPasswordReset(resetToken, nuevaPassword);
      onVolverALogin('Contraseña actualizada. Iniciá sesión con tu nueva contraseña.');
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      {paso === 1 && (
        <>
          <p className="login-subtitulo">Ingresá tu email para recibir un código de recuperación.</p>
          <form className="login-form" onSubmit={manejarPedirCodigo}>
            <label className="login-label">
              Email
              <input
                type="email"
                className="login-input"
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </label>
            {error && <p className="login-error">{error}</p>}
            <button type="submit" className="login-btn" disabled={cargando}>
              {cargando ? 'Enviando...' : 'Enviar código'}
            </button>
          </form>
        </>
      )}

      {paso === 2 && (
        <>
          <p className="login-subtitulo">{mensajePaso1}</p>
          <form className="login-form" onSubmit={manejarValidarCodigo}>
            <label className="login-label">
              Código de 6 dígitos
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                className="login-input"
                placeholder="000000"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))}
                autoComplete="one-time-code"
              />
            </label>
            {error && <p className="login-error">{error}</p>}
            <button type="submit" className="login-btn" disabled={cargando}>
              {cargando ? 'Validando...' : 'Validar código'}
            </button>
            <button
              type="button"
              className="login-link-secundario"
              onClick={() => { setPaso(1); setCodigo(''); setError(''); }}
            >
              Pedir un código nuevo
            </button>
          </form>
        </>
      )}

      {paso === 3 && (
        <>
          <p className="login-subtitulo">Código validado. Ingresá tu nueva contraseña.</p>
          <form className="login-form" onSubmit={manejarNuevaPassword}>
            <label className="login-label">
              Contraseña nueva
              <input
                type="password"
                className="login-input"
                placeholder="Mín. 8 caracteres"
                value={nuevaPassword}
                onChange={(e) => setNuevaPassword(e.target.value)}
                autoComplete="new-password"
              />
            </label>
            <p className="form-ayuda-password">
              Mínimo 8 caracteres. No puede ser una contraseña muy común, completamente numérica, ni muy parecida a tu usuario, nombre o email.
            </p>
            <label className="login-label">
              Repetir contraseña
              <input
                type="password"
                className="login-input"
                placeholder="Repetir contraseña"
                value={confirmarPassword}
                onChange={(e) => setConfirmarPassword(e.target.value)}
                autoComplete="new-password"
              />
            </label>
            {error && <p className="login-error">{error}</p>}
            <button type="submit" className="login-btn" disabled={cargando}>
              {cargando ? 'Guardando...' : 'Actualizar contraseña'}
            </button>
          </form>
        </>
      )}

      <button
        type="button"
        className="login-link-secundario login-recuperar-volver"
        onClick={() => onVolverALogin('')}
      >
        Volver a iniciar sesión
      </button>
    </>
  );
}

export default RecuperarContrasena;
